/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SapUserDataResponse
 */
export interface SapUserDataResponse {
    /**
     * 
     * @type {Date}
     * @memberof SapUserDataResponse
     */
    employmentStartDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    initials?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobCode2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    personCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sapUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sectionCode?: string | null;
}

/**
 * Check if a given object implements the SapUserDataResponse interface.
 */
export function instanceOfSapUserDataResponse(value: object): value is SapUserDataResponse {
    return true;
}

export function SapUserDataResponseFromJSON(json: any): SapUserDataResponse {
    return SapUserDataResponseFromJSONTyped(json, false);
}

export function SapUserDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SapUserDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'employmentStartDate': json['employmentStartDate'] === undefined ? undefined : json['employmentStartDate'] === null ? null : (new Date(json['employmentStartDate'])),
        'initials': json['initials'] === undefined ? undefined : json['initials'] === null ? null : json['initials'],
        'jobCode2': json['jobCode2'] === undefined ? undefined : json['jobCode2'] === null ? null : json['jobCode2'],
        'jobTitle': json['jobTitle'] === undefined ? undefined : json['jobTitle'] === null ? null : json['jobTitle'],
        'personCity': json['personCity'] === undefined ? undefined : json['personCity'] === null ? null : json['personCity'],
        'sapUserId': json['sapUserId'] === undefined ? undefined : json['sapUserId'] === null ? null : json['sapUserId'],
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
    };
}

export function SapUserDataResponseToJSON(json: any): SapUserDataResponse {
    return SapUserDataResponseToJSONTyped(json, false);
}

export function SapUserDataResponseToJSONTyped(value?: SapUserDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employmentStartDate': value['employmentStartDate'] == null ? value['employmentStartDate'] : value['employmentStartDate'].toISOString(),
        'initials': value['initials'],
        'jobCode2': value['jobCode2'],
        'jobTitle': value['jobTitle'],
        'personCity': value['personCity'],
        'sapUserId': value['sapUserId'],
        'sectionCode': value['sectionCode'],
    };
}

